module.exports = __webpack_public_path__ + "img/wein.ab29c98b.jpg";